<template>
  <p v-bind="$attrs" class="text-error-500 text-xs" aria-live="assertive">
    {{ typeof errors === 'string' ? errors : errors.join(', ') }}
  </p>
</template>

<script setup>
defineProps({
  errors: {
    type: [Array, String],
    default: '',
  },
})
</script>
